import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps
} from '@mui/material';
import { FormFieldApi } from '../types';

export interface CheckboxProps extends Omit<MuiCheckboxProps, 'name' | 'onChange' | 'onBlur' | 'checked'> {
  field: FormFieldApi<boolean>;
  name: string;
  label: string;
  helperText?: string;
}

/**
 * Checkbox component that integrates with TanStack Form
 */
export const Checkbox = ({
  field,
  name,
  label,
  helperText,
  ...props
}: CheckboxProps) => {
  const { state, getMeta } = field;
  const meta = getMeta();
  const error = meta.touchedErrors.length > 0;
  const errorMessage = meta.touchedErrors[0] as string | undefined;

  return (
    <FormControl error={error}>
      <FormControlLabel
        control={
          <MuiCheckbox
            name={name}
            checked={!!state.value}
            onChange={(e) => field.handleChange(e.target.checked)}
            onBlur={() => field.handleBlur()}
            {...props}
          />
        }
        label={label}
      />
      {(error || helperText) && (
        <FormHelperText>{error ? errorMessage : helperText}</FormHelperText>
      )}
    </FormControl>
  );
}; 